export const SECURITY_URL = "https://the-tribe.xyz";
